interface AdminState {
  isImpersonating: boolean
  usersNewPassword: string
}

const state: AdminState = {
  isImpersonating: false,
  usersNewPassword: '',
}

export { AdminState, state }
